import { render, staticRenderFns } from "./WorkflowPreview.vue?vue&type=template&id=21f27c9c"
import script from "./WorkflowPreview.vue?vue&type=script&lang=ts"
export * from "./WorkflowPreview.vue?vue&type=script&lang=ts"
import style0 from "./WorkflowPreview.vue?vue&type=style&index=0&id=21f27c9c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports